export const PREFERRED_STYLE_CATALOG = Object.freeze([
  {
    id: "afrobeat",
    label: "Afrobeat",
    aliases: ["afrobeats", "naija beats"],
  },
  {
    id: "ambient",
    label: "Ambient",
    aliases: ["downtempo", "soundscape"],
  },
  {
    id: "alternative-rock",
    label: "Alternative Rock",
    aliases: ["alt rock"],
  },
  {
    id: "baroque",
    label: "Baroque",
    aliases: ["baroque classical"],
  },
  {
    id: "black-metal",
    label: "Black Metal",
    aliases: ["atmospheric black metal"],
  },
  {
    id: "blues",
    label: "Blues",
    aliases: ["delta blues", "electric blues"],
  },
  {
    id: "bluegrass",
    label: "Bluegrass",
    aliases: ["americana bluegrass"],
  },
  {
    id: "bossa-nova",
    label: "Bossa Nova",
    aliases: ["bossa", "brazilian jazz"],
  },
  {
    id: "breakbeat",
    label: "Breakbeat",
    aliases: ["breaks", "nu skool breaks"],
  },
  {
    id: "cinematic-orchestral",
    label: "Cinematic Orchestral",
    aliases: ["score", "soundtrack"],
  },
  {
    id: "classical-modern",
    label: "Classical (Modern)",
    aliases: ["neoclassical"],
  },
  {
    id: "country",
    label: "Country",
    aliases: ["country western"],
  },
  {
    id: "dance-pop",
    label: "Dance Pop",
    aliases: ["club pop"],
  },
  {
    id: "death-metal",
    label: "Death Metal",
    aliases: ["extreme metal"],
  },
  {
    id: "deep-house",
    label: "Deep House",
    aliases: ["deephouse"],
  },
  {
    id: "digital-fusion",
    label: "Digital Fusion",
    aliases: ["future jazz"],
  },
  {
    id: "disco",
    label: "Disco",
    aliases: ["nu disco", "classic disco"],
  },
  {
    id: "doom-metal",
    label: "Doom Metal",
    aliases: ["stoner doom", "sludge"],
  },
  {
    id: "drum-and-bass",
    label: "Drum & Bass",
    aliases: ["dnb", "jungle"],
  },
  {
    id: "dubstep",
    label: "Dubstep",
    aliases: ["wubstep"],
  },
  {
    id: "electro-swing",
    label: "Electro Swing",
    aliases: ["swing house"],
  },
  {
    id: "electronic-noir",
    label: "Electronic Noir",
    aliases: ["dark electronica"],
  },
  {
    id: "emo",
    label: "Emo",
    aliases: ["emo rock", "emo punk"],
  },
  {
    id: "experimental-pop",
    label: "Experimental Pop",
    aliases: ["alt pop"],
  },
  {
    id: "folk-acoustic",
    label: "Folk Acoustic",
    aliases: ["modern folk"],
  },
  {
    id: "funk",
    label: "Funk",
    aliases: ["boogie", "groove"],
  },
  {
    id: "future-bass",
    label: "Future Bass",
    aliases: ["bass music"],
  },
  {
    id: "garage",
    label: "Garage",
    aliases: ["ukg", "2-step"],
  },
  {
    id: "grunge",
    label: "Grunge",
    aliases: ["90s grunge"],
  },
  {
    id: "hardstyle",
    label: "Hardstyle",
    aliases: ["hard dance"],
  },
  {
    id: "hip-hop",
    label: "Hip-Hop",
    aliases: ["rap"],
  },
  {
    id: "house-classic",
    label: "House",
    aliases: ["classic house", "chicago house"],
  },
  {
    id: "hyperpop",
    label: "Hyperpop",
    aliases: ["glitch pop"],
  },
  {
    id: "idm",
    label: "IDM",
    aliases: ["intelligent dance music"],
  },
  {
    id: "indie-rock",
    label: "Indie Rock",
    aliases: ["independent rock"],
  },
  {
    id: "indietronica",
    label: "Indietronica",
    aliases: ["indie electronic"],
  },
  {
    id: "industrial",
    label: "Industrial",
    aliases: ["industrial rock", "industrial dance"],
  },
  {
    id: "jazz-traditional",
    label: "Jazz (Traditional)",
    aliases: ["swing jazz"],
  },
  {
    id: "jazztronica",
    label: "Jazztronica",
    aliases: ["nu jazz"],
  },
  {
    id: "k-pop",
    label: "K-Pop",
    aliases: ["korean pop"],
  },
  {
    id: "latin-pop",
    label: "Latin Pop",
    aliases: ["pop latino"],
  },
  {
    id: "lofi-chill",
    label: "Lo-Fi Chill",
    aliases: ["chillhop", "study beats"],
  },
  {
    id: "melodic-techno",
    label: "Melodic Techno",
    aliases: ["melodic house techno"],
  },
  {
    id: "metal",
    label: "Metal",
    aliases: ["heavy metal"],
  },
  {
    id: "metalcore",
    label: "Metalcore",
    aliases: ["melodic metalcore"],
  },
  {
    id: "modular-experimentation",
    label: "Modular Experimentation",
    aliases: ["eurorack"],
  },
  {
    id: "neo-soul",
    label: "Neo-Soul",
    aliases: ["modern soul"],
  },
  {
    id: "new-wave",
    label: "New Wave",
    aliases: ["80s new wave"],
  },
  {
    id: "pop",
    label: "Pop",
    aliases: ["mainstream pop"],
  },
  {
    id: "post-rock",
    label: "Post-Rock",
    aliases: ["postrock"],
  },
  {
    id: "progressive-house",
    label: "Progressive House",
    aliases: ["prog house"],
  },
  {
    id: "progressive-metal",
    label: "Progressive Metal",
    aliases: ["prog metal"],
  },
  {
    id: "psychedelic-groove",
    label: "Psychedelic Groove",
    aliases: ["psych funk"],
  },
  {
    id: "punk",
    label: "Punk",
    aliases: ["punk rock"],
  },
  {
    id: "rnb-soul",
    label: "R&B / Soul",
    aliases: ["rnb", "contemporary soul"],
  },
  {
    id: "reggae",
    label: "Reggae",
    aliases: ["roots reggae"],
  },
  {
    id: "reggaeton",
    label: "Reggaeton",
    aliases: ["urbano", "latin trap"],
  },
  {
    id: "rock",
    label: "Rock",
    aliases: ["classic rock"],
  },
  {
    id: "singer-songwriter",
    label: "Singer-Songwriter",
    aliases: ["acoustic pop"],
  },
  {
    id: "ska",
    label: "Ska",
    aliases: ["ska punk"],
  },
  {
    id: "soft-rock",
    label: "Soft Rock",
    aliases: ["adult contemporary"],
  },
  {
    id: "soul",
    label: "Soul",
    aliases: ["classic soul", "motown"],
  },
  {
    id: "synth-pop",
    label: "Synth-Pop",
    aliases: ["synthpop", "new romantic"],
  },
  {
    id: "synthwave",
    label: "Synthwave",
    aliases: ["retrowave"],
  },
  {
    id: "techno",
    label: "Techno",
    aliases: ["detroit techno"],
  },
  {
    id: "trap",
    label: "Trap",
    aliases: ["trap hip-hop"],
  },
  {
    id: "trance",
    label: "Trance",
    aliases: ["uplifting trance", "progressive trance"],
  },
  {
    id: "trip-hop",
    label: "Trip-Hop",
    aliases: ["downtempo hip-hop"],
  },
  {
    id: "uk-drill",
    label: "UK Drill",
    aliases: ["drill"],
  },
  {
    id: "vaporwave",
    label: "Vaporwave",
    aliases: ["aesthetic vapor"],
  },
  {
    id: "vocal-jazz",
    label: "Vocal Jazz",
    aliases: ["jazz vocal"],
  },
  {
    id: "world-fusion",
    label: "World Fusion",
    aliases: ["global fusion"],
  },
]);

export default PREFERRED_STYLE_CATALOG;
